export default {
  // 標籤管理
  labelManagement: "標籤管理",
};
